module.exports = __webpack_public_path__ + "static/img/1.12157c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/xunlonggaoshou/1.jpg
// module id = Aukv
// module chunks = 1